import {
  SET_TIPOS_DE_DATO,
  SET_NATURALEZAS_DE_INGRESO,
  SET_FUENTES,
  SET_METODOS_DE_PAGO,
  SET_TIPOS_DE_PRESUPUESTOS,
  SET_MONEDAS,
} from 'store/reducers/catalogs';
import { store } from 'store';
import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import formatValues, { hasFiles } from 'utils/formatValues';
import Moment from 'moment';

const files = ['documento'];
const headers = { 'Content-Type': 'multipart/form-data' };

/**
 * GET tipos de caracteres
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeCaracteres = async (params = null) => {
  try {
    const response = await API.get('configuracion/tipos-de-caracteres/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET catalogos de valor
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCatalogosDeValor = async (params = null) => {
  try {
    const response = await API.get('configuracion/catalogos-de-valor/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Catálogo de Canales de Pago
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCatalogoDeCanalesDePago = async (params = null) => {
  try {
    const response = await API.get('configuracion/catalogos-de-canales-de-pago/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Pagos
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDePagos = async (params = null) => {
  try {
    const response = await API.get('configuracion/tipos-de-pagos/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Fuentes
 * @returns {Promise<Array<Object>>}
 */
export const getFuentes = async () => {
  try {
    const { fuentes } = store.getState().catalogs;
    if (!fuentes?.length) {
      const response = await API.get('configuracion/fuentes/');
      store.dispatch({
        type: SET_FUENTES,
        payload: response.data,
      });
      return response.data;
    }
    return fuentes;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Normatividades
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getNormatividades = async (params = null) => {
  try {
    const response = await API.get('configuracion/normatividades/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET INPCs
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getINPCs = async (params = null) => {
  try {
    const response = await API.get('configuracion/inpc/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * POST INPCs
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postINPCs = async (values) => {
  try {
    const response = await API.post('configuracion/inpc/', values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * PATCH INPC
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchINPC = async (id, values) => {
  try {
    const response = await API.patch(`configuracion/inpc/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE INPC
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteINPc = async (id) => {
  try {
    const response = await API.delete(`configuracion/inpc/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Monedas
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getMonedas = async (params = null) => {
  try {
    const { monedas } = store.getState().catalogs;
    if (!monedas?.length) {
      const response = await API.get('configuracion/monedas/', { params });
      store.dispatch({
        type: SET_MONEDAS,
        payload: response.data,
      });
      return response.data;
    }
    return monedas;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET UMAs
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getUMAs = async (params = null) => {
  try {
    const response = await API.get('configuracion/uma/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST UMAs
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postUMAs = async (values) => {
  try {
    const response = await API.post('configuracion/uma/', values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * PATCH UMAs
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchUMAs = async (id, values) => {
  try {
    const response = await API.patch(`configuracion/uma/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE UMAs
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteAUMAs = async (id) => {
  try {
    const response = await API.delete(`configuracion/uma/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Afectaciones Presupuestales
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getAfectacionesPresupuestales = async (params = null) => {
  try {
    const response = await API.get('configuracion/afectaciones-presupuestales/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Clasificaciones
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getClasificaciones = async (params = null) => {
  try {
    const response = await API.get('configuracion/clasificaciones/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Momentos Presupuestales Del Egreso
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getMomentosPresupuestalesDelEgreso = async (params = null) => {
  try {
    const response = await API.get('configuracion/momentos-presupuestales-del-egreso/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Momentos Presupuestales Del Ingreso
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getMomentosPresupuestalesDelIngreso = async (params = null) => {
  try {
    const response = await API.get('configuracion/momentos-presupuestales-del-ingreso/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Naturalezas de Ingreso
 * @returns {Promise<Array<Object>>}
 */
export const getNaturalezasDeIngreso = async () => {
  try {
    const { naturalezasDeIngreso } = store.getState().catalogs;
    if (!naturalezasDeIngreso?.length) {
      const response = await API.get('configuracion/naturalezas-de-ingreso/');
      store.dispatch({
        type: SET_NATURALEZAS_DE_INGRESO,
        payload: response.data,
      });
      return response.data;
    }
    return naturalezasDeIngreso;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Naturalezas
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getNaturalezas = async (params = null) => {
  try {
    const response = await API.get('configuracion/naturalezas/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Cuentas Contables
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeCuentasContables = async (params = null) => {
  try {
    const response = await API.get('configuracion/tipos-de-cuenta-contable/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Datos
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeDato = async (params = null) => {
  try {
    if (!store.getState()?.catalogs.tiposDeDato?.length) {
      const response = await API.get('configuracion/tipos-de-datos/', { params });
      store.dispatch({
        type: SET_TIPOS_DE_DATO,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState()?.catalogs.tiposDeDato;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Usos de Folios
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getUsosDeFolios = async (params = null) => {
  try {
    const response = await API.get('configuracion/usos-de-folios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Salarios Minimos
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getSalariosMinimos = async (params = null) => {
  try {
    const response = await API.get('configuracion/salarios-minimos/', { params });
    const formatted = response.data.map((item) => ({
      ...item,
      anio: item?.inicio_de_vigencia
        ? parseInt(item.inicio_de_vigencia.split('-')[0], 10) : null,
    }));
    return formatted;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Tarifas
 * @returns {Promise<Arrar<Object>>}
 */
export const getTiposDeTarifa = async () => {
  try {
    const response = await API.get('configuracion/tipos-de-tarifas');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/*
 * GET Tipos de Cuentas Bancarias
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeCuentasBancarias = async (params = null) => {
  try {
    const response = await API.get('configuracion/tipos-de-cuentas-bancarias/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 *
 * @param {object} values
 * @returns {promise<boolean>}
 */
export const postGenerarAlerta = async (values, { clave, idPadron, accionInf } = {}) => {
  try {
    const _files = ['documento'];
    const config = hasFiles(values, _files) ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};

    // eslint-disable-next-line no-param-reassign
    values.fecha_de_cierre = values?.fecha_de_cierre
      ? `${values.fecha_de_cierre.format('YYYY-MM-DD')} 00:00:00` : null;

    // eslint-disable-next-line no-param-reassign
    values.fecha_de_registro_de_alerta = values?.fecha_de_registro_de_alerta
      ? `${values.fecha_de_registro_de_alerta.format('YYYY-MM-DD')} 00:00:00` : null;
    const formattedvalues = formatValues(values, {
      files: _files,
      formData: config.headers,
      clean: true,
    });

    const response = await API.post('/configuracion/alertas/', formattedvalues, {
      ...config, accionInf, id_padron: idPadron, clave,
    });
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const patchAlertas = async (id, values, { clave, idPadron, accionInf } = {}) => {
  try {
    const _files = ['documento'];
    const config = hasFiles(values, _files) ? { headers } : {};
    const data = formatValues(values, {
      formData: config?.headers,
      files,
      clean: false,
    });

    const fecha_de_cancelacion = data?.fecha_de_cancelacion
      ? `${data.fecha_de_cancelacion} 00:00:00` : null;
    if (data?.fecha_de_cierre) {
      data.fecha_de_cierre = `${data.fecha_de_cierre} 00:00:00`;
    }

    const response = await API.patch(`/configuracion/alertas/${id}/`, {
      ...data,
      fecha_de_cancelacion,
    },
    {
      ...config, accionInf, id_padron: idPadron, clave,
    });
    onSuccess(response, 'Modificado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Retiro de Caja
 * @param {object} values
 * @returns {Promise <boolean>}
 */
export const retiroDeCaja = async (values) => {
  try {
    const response = await API.post('/configuracion/retiros-de-caja/', values);
    onSuccess(response, 'Retiro logrado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Metodos de Pago
 * @returns {Promise <Array<object>>}
 */
export const getMetodosDePago = async () => {
  try {
    const { metodosDePago } = store.getState().catalogs;
    if (!metodosDePago?.length) {
      const response = await API.get('/configuracion/catalogos-de-metodos-de-pagos/');
      store.dispatch({
        type: SET_METODOS_DE_PAGO,
        payload: response.data,
      });
      return response.data;
    }
    return metodosDePago;
  } catch (err) {
    onError(err);
    return [];
  }
};
/*
 * GET Tipos de Tipos de Presupuestos
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDePresupuestos = async (params = null) => {
  try {
    if (!store.getState()?.catalogs?.tiposPresupuestos?.length) {
      const response = await API.get('configuracion/tipos-de-presupuestos/', { params });
      store.dispatch({
        type: SET_TIPOS_DE_PRESUPUESTOS,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState().catalogs.tiposPresupuestos;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Origenes de Alertas
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getOrigenesDeAlertas = async (params = null) => {
  try {
    const response = await API.get('configuracion/origen-de-las-alertas/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Cuentas Contables
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCuentasContables = async (params) => {
  try {
    const resposne = await API.get('configuracion/cuenta-contable-administrador/', { params });
    return resposne.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Cuenta Contable
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCuentaContable = async (id) => {
  try {
    const resposne = await API.get(`configuracion/cuenta-contable-administrador/${id}`);
    return resposne.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

export const sendPDFToEmail = async (values) => {
  try {
    const response = await API.post('/configuracion/enviar-archivo-por-correo/', values);
    onSuccess(response, 'El documento ha sido enviado revise su bandeja de recepción');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const getCategoriasDeVariables = async (params) => {
  try {
    const response = await API.get('/empresas/categorias-de-variables/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Datos de Pago
 * @returns {Promise<Array<object>>}
 */
export const getDatosDePagos = async (params = null) => {
  try {
    const response = await API.get('configuracion/datos-de-pagos/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Datos de Pago
 * @returns {Promise<Array<object>>}
 */
export const getDatosDePagosById = async (id) => {
  try {
    const response = await API.get(`configuracion/datos-de-pagos/${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

export const getHoraDelServidor = async () => {
  try {
    const response = await API.get('/configuracion/server-timezone/');
    return new Moment(response.data.current_time);
  } catch (err) {
    onError(err);
    return null;
  }
};
